import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة القسمة المطولة - حل مسائل القسمة مع باقي";
const DESCRIPTION = "أداة متكاملة لحساب القسمة المطولة! تقوم حاسبتنا بإجراء عمليات القسمة مع إظهار الحل المفصل خطوة بخطوة، مع عرض الناتج والباقي. حل مسائل القسمة المطولة بسهولة ودقة عالية";
const KEYWORDS = "حاسبة قسمة مطولة، حاسبة القسمة، حاسبه قسمة، حل القسمة، قسمة مطولة، قسمة مع باقي، خطوات القسمة، آلة حاسبة قسمة، حل مسائل القسمة، رياضيات قسمة";
const OG_URL = "https://do-calculate.com/calculator/ar/long-division-calculator/";
function LongDivisionCalculator() {
  const [dividend, setDividend] = useState("");
  const [divisor, setDivisor] = useState("");
  const [result, setResult] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      setError("");
      const numDividend = parseInt(dividend);
      const numDivisor = parseInt(divisor);
      if (isNaN(numDividend) || isNaN(numDivisor)) {
        throw new Error("الرجاء إدخال أرقام صحيحة");
      }
      if (numDivisor === 0) {
        throw new Error("لا يمكن القسمة على صفر");
      }
      let quotient = Math.floor(numDividend / numDivisor);
      let remainder = numDividend % numDivisor;
      let calculationSteps = [];
      calculationSteps.push(`الخطوة 1: قسمة ${numDividend} على ${numDivisor}`);
      calculationSteps.push(`الخطوة 2: الناتج = ${quotient}`);
      calculationSteps.push(`الخطوة 3: الباقي = ${remainder}`);
      setResult({
        quotient,
        remainder,
        fraction: `${quotient}${remainder !== 0 ? ` والباقي ${remainder}` : ''}`,
        decimal: (numDividend / numDivisor).toFixed(12)
      });
      setSteps(calculationSteps);
    } catch (error) {
      setError(error.message);
    } 
  };
  const handleClear = () => {
    setDividend("");
    setDivisor("");
    setResult(null);
    setSteps([]);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة القسمة المطولة الشاملة: أداة مجانية وسهلة الاستخدام لحساب القسمة مع باقي
                  بكل بساطة وفعالية. تقوم الحاسبة بعرض خطوات الحل المفصلة مع الناتج والباقي.
                  مثالية لحل مسائل القسمة في الرياضيات، تساعدك الحاسبة على توفير الوقت والجهد
                  والحصول على نتائج دقيقة في ثوانٍ معدودة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة القسمة المطولة - حل مع خطوات</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="mx-2">
                        <input
                          type="number"
                          value={dividend}
                          onChange={(e) => setDividend(e.target.value)}
                          placeholder="المقسوم"
                          className="form-control"
                          style={{ width: "100px", textAlign: "center" }}
                        />
                      </div>
                      <div className="mx-2">
                        <span style={{ fontSize: "20px" }}>÷</span>
                      </div>
                      <div className="mx-2">
                        <input
                          type="number"
                          value={divisor}
                          onChange={(e) => setDivisor(e.target.value)}
                          placeholder="المقسوم عليه"
                          className="form-control"
                          style={{ width: "150px", textAlign: "center" }}
                        />
                      </div>
                    </div>
                    <br />
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn btn-success mx-2"
                        style={{ fontSize: "20px" }}
                        onClick={handleCalculate}
                      >
                        احسب                      </button>
                      <button
                        className="btn btn-danger mx-2"
                        style={{ fontSize: "20px" }}
                        onClick={handleClear}
                      >
                        مسح
                      </button>
                    </div>
                    <br />
                    { error !== "" && (
                      <p className="p-3 mb-2 bg-warning text-black">
                        خطأ: {error}
                      </p>
                    )}
                    {result !== null &&  (
                      <div className="p-3 mb-2 bg-success text-white">
                        <h4>النتيجة:</h4>
                        <div className="result">
                          <p>{dividend} ÷ {divisor} = {result.quotient} والباقي {result.remainder}</p>
                          <p>ككسر: {result.quotient}<sup>{result.remainder}</sup>/<sub>{divisor}</sub></p>
                          <p>كعدد عشري: {result.decimal}</p>
                        </div>
                        <div>
                          <h5>الخطوات:</h5>
                          {steps.map((step, index) => (
                            <p key={index}>{step}</p>
                          ))}
                        </div>
                      </div>
                    )}
                    <hr />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <b><u>ما هي حاسبة القسمة المطولة؟</u></b>
                <p>
                  حاسبة القسمة المطولة هي أداة تساعدك على إجراء عمليات القسمة مع باقي
                  وعرض الخطوات التفصيلية للحل. تعرض الحاسبة الناتج والباقي وكذلك
                  الشكل العشري للنتيجة.
                </p>
                <b><u>كيفية استخدام الحاسبة</u></b>
                <p>
                  لاستخدام الحاسبة، قم بإدخال المقسوم والمقسوم عليه، ثم انقر على زر
                  "احسب" للحصول على النتيجة والخطوات التفصيلية.
                </p>
                <b><u>شرح النتائج</u></b>
                <p>
                  ستعرض الحاسبة النتيجة بعدة أشكال: الناتج والباقي، ككسر، وكعدد عشري.
                  كما تعرض الخطوات التفصيلية للوصول إلى الحل.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default LongDivisionCalculator;